import React from 'react';
import moment from 'moment';
import { TextField, Grid, Chip, IconButton, Checkbox, Tooltip, FormControlLabel } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker, DatePicker
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ReactChipInput from '../components/common/ChipInput/ReactChipInput';
import _ from 'lodash';
import { removeDuplicates, getDistinctByProperty, numberWithCommas, IsReimbursementAmountAccess, with2DecimalsPoints } from './helper';
import { Switch } from '../components/common/Switch/index';
import InputMask from 'react-input-mask';
import { Add, Remove } from '@material-ui/icons';
import Clear from '@material-ui/icons/Clear';
import Fab from '@material-ui/core/Fab';

export function getColumnControl(
  row,
  column,
  handleTableHeaderEditChange
) {
  const value = (row || {})[column.key];
  const editConfig = column.editConfig;
  switch ((editConfig.type || '').trim()) {
    case 'Checkbox':
      return (
        <>
          <Tooltip title={!value ? editConfig.toolTip1 : editConfig.toolTip2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={value}
                  onChange={(e) => handleTableHeaderEditChange(e.target.checked, column.key)}
                  name={editConfig.name}
                  color="default"
                  size="small"
                  className={'white-checkbox'}
                />
              }
            />
          </Tooltip>
        </>
      );
    default:
      return false;
  }
}
function getFormattedData(
  row,
  column,
  isInAddMode,
  EditSource,
  selectedEditRowId,
  handleTableValueChange,
  showLabel = false,
  props,
  index = 0,
  viewTagData,
  showCollapsible,
  handelCollapsible,
  selected,
  isReport = '',
  columnIndex = undefined
) {
  // function disableDatesForPayCycleStart(date) {
  //   if (column.isPayCycle) {
  //     if (date.getDate() === 1 || date.getDate() === 16) {
  //       return false;
  //     }
  //     return true;
  //   }
  //   return false;
  // }

  let value = (row || {})[column.key];
  if (
    (column.editConfig !== undefined && column.editConfig.multiple) ||
    _.camelCase(column.dataFormat) === _.camelCase('MultiText')
  ) {
    value = value ? (value || '').split('|') : [];
  }

  let label = <></>;
  if (showLabel === true) {
    label = <div> {column.name} </div>;
  }
  const notEditTypeValue = (column.notEditWhen || {}).value;
  const notEditTypeKey = (column.notEditWhen || {}).key;
  if (
    (selectedEditRowId !== undefined &&
      // column.isEditable === true &&
      column.editConfig !== undefined &&
      row[selectedEditRowId.key] === selectedEditRowId.value &&
      column.editConfig.isEditField === true &&
      isInAddMode === false &&
      (column.notEditWhen === undefined ||
        notEditTypeValue !== row[notEditTypeKey])) ||
    (selectedEditRowId !== undefined &&
      // column.isEditable === true &&
      column.editConfig !== undefined &&
      row[selectedEditRowId.key] === selectedEditRowId.value &&
      column.editConfig.isAddField === true &&
      isInAddMode === true &&
      (column.notEditWhen === undefined ||
        notEditTypeValue !== row[notEditTypeKey]))
  ) {
    const dataSource = _.cloneDeep(EditSource.find((x) => x.key === column.editConfig?.sourceKey));
    if (column.filterMultipleSourceOn) {
      let dropdownSource = [];
      column.filterMultipleSourceOn.forEach((ele) => {
        const idValue = row[ele.key];
        if (idValue) {
          dropdownSource = dataSource.data.filter((x) =>
          ((x[ele.filterSingleKey] || '').toString() === (idValue || '').toString() ||
            (x[ele.filterBy] !== null && (x[ele.filterBy] || '').split('|').indexOf((idValue || '').toString()) !== -1) ||
            (ele.ignoreWhen && x[ele.ignoreWhen.key]?.toString() === ele.ignoreWhen.value?.toString())
          ));
          dataSource.data = dropdownSource.filter((ele, ind) => ind === dropdownSource.findIndex(elem => elem[column.fieldId] === ele[column.fieldId]));
        }
      });
    }
    if (column.filterSourceOn) {
      let dropdownSource = [];
      if (column?.filterOnSameSource) {
        column.filterSourceOn.forEach((ele) => {
          const idValue = row[ele.key];
          if (idValue) {
            // dropdownSource = dataSource.data.filter((x) =>
            //   ((x[ele.filterBy] || '').toString() === (idValue || '').toString() ||
            //   (ele.ignoreWhen && x[ele.ignoreWhen.key]?.toString() === ele.ignoreWhen.value?.toString())));
            const arr = [];
            idValue.split('|').forEach(x => {
              const index = dataSource.data.findIndex(y => y.accessGroupId == x);
              dataSource.data?.splice(index, 1);
            });
            console.log(dataSource.data);
            // dataSource.data = dropdownSource.filter((ele, ind) => ind === dropdownSource.findIndex(elem => elem[column.fieldId] !== ele[column.fieldId]));
          }
        });
      } else {
        column.filterSourceOn.forEach((ele) => {
          const idValue = row[ele.key];
          if (idValue) {
            dropdownSource = dataSource.data.filter((x) =>
            ((x[ele.filterBy] || '').toString() === (idValue || '').toString() ||
              (ele.ignoreWhen && x[ele.ignoreWhen.key]?.toString() === ele.ignoreWhen.value?.toString())));
            dataSource.data = dropdownSource.filter((ele, ind) => ind === dropdownSource.findIndex(elem => elem[column.fieldId] === ele[column.fieldId]));
          }
        });
      }
    }

    if (column.editConfig?.distinctOn) {
      dataSource.data = getDistinctByProperty(dataSource.data, column.editConfig?.distinctOn);
    }
    const isInErrorState = column.isInErrorState;
    const errorMessage = column.errorMessage;
    const isEditable = selectedEditRowId.mode === 'View' ? true : column.disabled;
    const isAvoidFormatting = column.editConfig?.isAvoidFormatting ?? false;
    if (showLabel === true) {
      label = <div> {<><span>{column.name}</span> {!isEditable && column.isRequired ? <span className="error-text">*</span> : ''}</>} </div>;
    }
    const width = column.width !== undefined ? column.width : '100%';
    if (!isEditable) {
      switch ((column.editConfig.type || '').trim()) {
        case 'DropDown':
          return (
            <>
              <b>{label}</b>
              <Autocomplete
                size="small"
                style={{ width: width }}
                disabled={isEditable}
                error={isInErrorState}
                helperText={errorMessage}
                multiple={column.editConfig.multiple || false}
                limitTags={2}
                options={(dataSource.data || []).map(
                  (option) => option[column.editConfig.sourceOption]
                )}
                value={column.editConfig.multiple === true ? value || [] : value}
                className="editable"
                key={'dropDown_filter' + column.editConfig.title}
                id={'dropDown_filter' + column.editConfig.title}
                onChange={(event, value) => {
                  handleTableValueChange(
                    getFormattedValues(value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  );
                }}
                autoHighlight
                renderInput={(params) => (
                  <TextField
                    disabled={isEditable}
                    error={isInErrorState}
                    helperText={errorMessage}
                    {...params}
                    margin="normal"
                    className="table-text"
                  />
                )}
              />
            </>
          );
        case 'TextField':
          return (
            <>
              <b>{label}</b>
              <TextField
                style={{ width: width }}
                disabled={isEditable}
                error={isInErrorState}
                helperText={errorMessage}
                margin="normal"
                size="small"
                color="primary"
                className="editable"
                // value={isAvoidFormatting ? (isNaN(value) ? 0 : ((value?.toString() || '').slice(-1) === '.' ? value : (Math.round(Math.abs((value)) * 100) / 100))) : getFormattedValues(value, column.dataFormat, true)}
                value={isAvoidFormatting ? (isNaN(value) ? 0 : ((value?.toString() || '').indexOf('.') >= 0 ? value : (Math.round(Math.abs((value)) * 100) / 100))) : getFormattedValues(value, column.dataFormat, true)}
                onChange={(e) =>
                  handleTableValueChange(
                    isAvoidFormatting ? (isNaN(e.target.value) ? 0 : (e.target.value?.toString() || '' === '.' ? e.target.value : (Math.round(Math.abs((e.target.value)) * 100) / 100))) : getFormattedValues(e.target.value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )
                }
              />
            </>
          );
        case 'PhoneNumber':
          return (
            <>
              <b>{label}</b>

              <InputMask
                mask="999-999-9999"
                style={{ width: width }}
                value={getFormattedValues(value, column.dataFormat, true)}
                disabled={isEditable}
                maskChar=" "
                onChange={(e) =>
                  handleTableValueChange(
                    getFormattedValues(e.target.value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )
                }
              >
                {() => <TextField

                  error={isInErrorState}
                  helperText={errorMessage}
                  margin="normal"
                  size="small"
                  color="primary"
                  className="editable" />}
              </InputMask>

            </>
          );
        case 'TextNumber':
          return (
            <>
              <b>{label}</b>
              <TextField
                disabled={isEditable}
                error={isInErrorState}
                helperText={errorMessage}
                style={{ width: width }}
                margin="normal"
                size="small"
                color="primary"
                className="editable"
                type="number"
                // value={isAvoidFormatting ? (isNaN(value) ? 0 : ((value?.toString() || '').slice(-1) === '.' ? value : (Math.round(Math.abs((value)) * 100) / 100))) : getFormattedValues(value, column.dataFormat, true)}
                // value={isAvoidFormatting ? (isNaN(value) ? 0 : ((value?.toString() || '').indexOf('.') >= 0 ? value : (Math.round(Math.abs((value)) * 100) / 100))) : getFormattedValues(value, column.dataFormat, true)}
                value={column?.decimalPrecision === 2 ? with2DecimalsPoints(value, 'Percent') : value}
                onChange={(e) =>
                  handleTableValueChange(
                    // isAvoidFormatting ? (isNaN(e.target.value) ? 0 : (e.target.value?.toString() || '' === '.' ? e.target.value : (Math.round(Math.abs((e.target.value)) * 100) / 100))) : getFormattedValues(e.target.value, column.dataFormat, true),
                    e.target.value,
                    column.key,
                    row,
                    isInAddMode,
                    index
                  )
                }
              />
            </>
          );
        case 'DatePicker':
          return (
            <>
              <b>{label}</b>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                key={'datePicker_filter' + column.key + index}
              >
                <Grid container>
                  <KeyboardDatePicker
                    style={{ width: width }}
                    disabled={isEditable}
                    error={isInErrorState}
                    clearable={true}
                    helperText={errorMessage}
                    minDate={column.minDate}
                    maxDate={column.maxDate}
                    className="editable"
                    size="small"
                    margin="normal"
                    key={'datePickerFilter' + column.key + index}
                    id="date-picker-dialog"
                    // shouldDisableDate={(date) => { disableDatesForPayCycleStart(date, column.isPayCycle); }}
                    // inputValue={value  || null}
                    shouldDisableDate={column.editConfig.shouldDisableDate}
                    value={value || null}
                    onChange={(date) => {
                      // if (
                      //   date !== '' &&
                      //   moment(date).format('MM/DD/YYYY') !== 'Invalid date'
                      // ) {if(dat)
                      handleTableValueChange(
                        getFormattedValues(date, column.dataFormat, true),
                        column.key,
                        row,
                        isInAddMode,
                        index
                      );
                      // }
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={(e) => {
                          document.getElementById('date-picker-dialog').value = '';

                          handleTableValueChange(
                            null,
                            column.key,
                            row,
                            isInAddMode,
                            index
                          );
                        }}>
                          <Clear />
                        </IconButton>
                      )
                    }}
                    format="MM/dd/yyyy"

                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </>
          );

        case 'YearPicker':
          return (
            <>
              <b>{label}</b>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                key={'datePicker_filter' + column.key + index}
              >
                <Grid container>
                  <KeyboardDatePicker
                    style={{ width: width }}
                    disabled={isEditable}
                    error={isInErrorState}
                    clearable={true}
                    helperText={errorMessage}
                    minDate={column.minDate}
                    maxDate={column.maxDate}
                    className="editable"
                    size="small"
                    margin="normal"
                    key={'datePickerFilter' + column.key + index}
                    id="date-picker-dialog"
                    views={['year']}
                    shouldDisableDate={column.editConfig.shouldDisableDate}
                    value={value || null}
                    onChange={(date) => {
                      handleTableValueChange(
                        getFormattedValues(date, column.dataFormat, true),
                        column.key,
                        row,
                        isInAddMode,
                        index
                      );
                    }}
                    InputProps={{
                      endAdornment: (
                        <IconButton onClick={(e) => {
                          document.getElementById('date-picker-dialog').value = '';

                          handleTableValueChange(
                            null,
                            column.key,
                            row,
                            isInAddMode,
                            index
                          );
                        }}>
                          <Clear />
                        </IconButton>
                      )
                    }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </>
          );
        case 'ChipInput':
          return (
            <>
              <ReactChipInput
                style={{ width: width }}
                required={column.isRequired}
                className={'custom-chipinput'}
                value={value}
                onChange={(value) => {
                  handleTableValueChange(
                    getFormattedValues(value, column.dataFormat, true),
                    column.key,
                    row,
                    isInAddMode,
                    index
                  );
                }}
              />
            </>
          );
        case 'Switch':
          return (
            <>
              <Switch
                style={{ width: width }}
                disabled={isEditable}
                isChecked={value}
                onChangeValues={(e, key) =>
                  handleTableValueChange(getFormattedValues(e, column.dataFormat, true), column.key, row, isInAddMode, index)
                }
                id={`label-${column.key}`}
                key={column.key}
                fieldkey={column.key}
                obj={column}
                labelText={column.name}
                fullWidth
                row={row}
                column={column}
                isInAddMode={isInAddMode}
                toolTip={column.editConfig.toolTip}
              />
            </>
          );
        case 'CheckBox':
          return (
            <>
              <Checkbox
                style={{ width: width }}
                checked={value}
                disabled={isEditable}
                onChange={(e) => handleTableValueChange(e.target.checked, column.key, row, isInAddMode, index)}
                fieldkey={column.key}
                obj={column}
                labelText={column.name}
                fullWidth
                row={row}
                column={column}
                isInAddMode={isInAddMode}
              />
            </>
          );
        default:
          return false;
      }
    } else {
      return formattedComponent(column, row, value, props, viewTagData, showCollapsible, selected, handelCollapsible, index, label, selectedEditRowId, isReport, columnIndex);
    }
  } else {
    return formattedComponent(column, row, value, props, viewTagData, showCollapsible, selected, handelCollapsible, index, label, selectedEditRowId, isReport, columnIndex);
  }
}
function formattedComponent(column, row, value, props, viewTagData, showCollapsible, selected, handelCollapsible, index, label, selectedEditRowId, isReport = '', columnIndex) {
  if (column.concatFields) {
    column.concatFields.forEach((field) => {
      const concatValue = row[field] || '';
      if (concatValue.length > 0) {
        value = value + ' ' + concatValue;
      }
    });
  }
  const isSensitive = column.isSensitive !== undefined ? row[column.isSensitive.key] === column.isSensitive.value && !IsReimbursementAmountAccess() : false;
  const component = getFormattedValues(value,
    column.dataFormat,
    false, column,
    props,
    viewTagData, '',
    (selectedEditRowId !== undefined && selectedEditRowId.value !== undefined),
    props?.config?.collapsibleMultilevel, isSensitive, row, isReport, columnIndex);
  const collapsibleComponent =
    showCollapsible && props.config && selected.key === column.key &&
      showCollapsible
      ? getCollapsibleIcon(row, column, handelCollapsible, index, selected.isOpen)
      : <></>;
  if (column.applyColorBadge) {
    return (
      <>
        {collapsibleComponent}
        <>
          <b>{label}</b>
          {applyBadge(component, value, (props.isInAddMode || (selectedEditRowId !== undefined && selectedEditRowId.value !== undefined)))}
        </>
      </>
    );
  } else {
    if ((showCollapsible && props.config && selected.key === column.key &&
      showCollapsible)) {
      return (<div className="row">
        <div className="collapse-button-container col-xs-2 no-padding">
          {collapsibleComponent}
        </div>
        <div className="col-xs-10" style={{ paddingTop: '4px' }}>
          <b>{label}</b>
          {component}
        </div>
      </div>);
    } else {
      return (
        <>
          {collapsibleComponent}
          <b>{label}</b>
          {component}
        </>
      );
    }
  }
}
export { getFormattedData, getFormattedValues, getFormattedValuesForReport, getWithoutFormattedValues, getFormattedStringValues };

function getFormattedValuesForReport(value, format, symbol) {
  if (symbol === '%') {
    if (value === '' || value === undefined) {
      return <span className={'number-text'}>-</span>;
    } else if (isNaN(value) !== true) {
      if (value >= 0) {
        return <span className={'report-percent-text'}>{numberWithCommas(with2DecimalsPoints(parseFloat(value), 'Percent'))}%</span>;
      } else {
        const newValue = value?.toString();
        const oldValue = newValue?.substr(1);
        return <span className={'report-percent-text'}>({numberWithCommas(with2DecimalsPoints(parseFloat(oldValue), 'Percent'))})%</span>;
      }
    } else {
      return <span className={'report-percent-text'}>{numberWithCommas(with2DecimalsPoints(parseFloat(value), 'Percent'))}%</span>;
    }
  } else {
    if (value === '' || value === undefined) {
      return <span className={'number-text'}>-</span>;
    } else if (isNaN(value) !== true) {
      if (value >= 0) {
        return <span className={'report-percent-text'}>${numberWithCommas(with2DecimalsPoints(parseFloat(value), 'Percent'))}</span>;
      } else {
        const newValue = value?.toString();
        const oldValue = newValue?.substr(1);
        return <span className={'report-percent-text'}>$({numberWithCommas(with2DecimalsPoints(parseFloat(oldValue), 'Percent'))})</span>;
      }
    } else {
      return <span className={'report-percent-text'}>${numberWithCommas(with2DecimalsPoints(parseFloat(value), 'Percent'))}</span>;
    }
  }
}

function getFormattedStringValues(value, format, payCodeTypeId, symbol = '') {
  if (format === 'Text') {
    return value;
  } else if (format === 'Number') {
    if (isNaN(value) === true) {
      return <span className={'right-text'}>0</span>;
    }
    return <span className={'right-text'}>{value}</span>;
  } else if (format === 'MoneyDecimal') {
    if (value === '' || value === undefined || isNaN(value) === true) {
      if (payCodeTypeId === 4) {
        return <span className={'report-percent-text-right'}></span>;
      } else {
        return <span className={'report-percent-text-right'}>{0}{'%'}</span>;
      }
    }
    if (symbol === 'hr') {
      return <span className={'report-percent-text-right'}>{value}{' ' + symbol}</span>;
    }
    return <span className={'report-percent-text-right'}>{symbol !== '' ? symbol : '$'}{numberWithCommas(with2DecimalsPoints(value))}</span>;
  } else if (format === 'DecimalPercent') {
    if (value === '' || value === undefined || isNaN(value) === true) {
      if (payCodeTypeId === 4) {
        return <span className={'report-percent-text-right'}></span>;
      } else {
        return <span className={'report-percent-text-right'}>{0}{'%'}</span>;
      }
    }
    if (payCodeTypeId === 4) {
      return <span className={'report-percent-text-right'}></span>;
    } else {
      return <span className={'report-percent-text-right'}>{numberWithCommas(with2DecimalsPoints(value, 'Percent'))}{'%'}</span>;
    }
  }
}

function getFormattedValues(value, format, noFormatting = false, column = undefined, prop = undefined,
  viewTagData = undefined, appendText = '', isEditableMode = false, nodashes = false, isSensitive = false, row = undefined,
  isReportFormat = '', columnIndex = undefined) {
  let component = <></>;
  let classes = '';
  let className = '';
  if (column && column.applyColorBadge) {
    classes = ' applyColorBadge';
  }

  if (value === false && format === 'Text' && noFormatting !== true) {
    return component;
  }

  switch ((format || '').trim()) {
    case 'NewLineText':
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined) {
          component = (
            <span className="default-text">{(value + ' ' + appendText).split('<br/>').map((x) => (<>
              {x}
              <br />
            </>))}  </span>
          );
        } else {
          component = <span className="default-text">{nodashes ? '' : '-'}</span>;
        }
      } else {
        return value;
      }
      break;
    case 'Text':
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined) {
          if (columnIndex === 0) {
            component = (
              <span className="default-text">
                {columnIndex === 0 &&
                  prop.rowBadge &&
                  row[prop.rowBadge.key] === prop.rowBadge.equalsTo && (
                    <Tooltip title={prop.rowBadge.tooltip ? prop.rowBadge.tooltip : ''}>
                      <Fab className={prop.rowBadge.class + ' market-badge'}>
                        <span className='allocation-font-size'>{prop.rowBadge.title}</span>
                      </Fab>
                    </Tooltip>
                  )}
                {prop?.rowBadge?.separateBySpace && <span>{' '}</span>}
                {columnIndex === 0 &&
                  prop.swapBadge &&
                  row[prop.swapBadge.key] !== prop.swapBadge.notEqualsTo && row[prop.swapBadge.key] !== row[prop.swapBadge.referenceKey] && (
                    <Tooltip title={prop.swapBadge.tooltip ? prop.swapBadge.tooltip : ''}>
                      <Fab className={prop.swapBadge.class + ' property-badge'}>
                        <span className='allocation-font-size'>{prop.swapBadge.title}</span>
                      </Fab>
                    </Tooltip>
                  )}
                {prop?.swapBadge?.separateBySpace && <span>{' '}</span>}
                {columnIndex === 0 &&
                  prop.gracePeriodBadge &&
                  row[prop.gracePeriodBadge.key] === prop.gracePeriodBadge.equalsTo && (
                    <Tooltip title={prop.gracePeriodBadge.tooltip ? prop.gracePeriodBadge.tooltip : ''}>
                      <Fab className={prop.gracePeriodBadge.class + ' property-badge'}>
                        <span className='allocation-font-size'>{prop.gracePeriodBadge.title}</span>
                      </Fab>
                    </Tooltip>
                  )}
                {prop?.gracePeriodBadge?.separateBySpace && <span>{' '}</span>}
                {value + ' ' + appendText}
              </span>
            );
          } else {
            component = (
              <span className="default-text">{value + ' ' + appendText}  </span>
            );
          }
        } else {
          component = <span className="default-text">{nodashes ? '' : '-'}</span>;
        }
      } else {
        return value;
      }
      break;
    case 'TabText':
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined) {
          component = (
            <div style={{ whiteSpace: 'pre' }} className="default-text"><span>{value + ' ' + appendText}</span></div>
          );
        } else {
          component = <div style={{ whiteSpace: 'pre' }} className="default-text"><span>{nodashes ? '' : '-'}</span></div>;
        }
      } else {
        return value;
      }
      break;
    case 'TextNew':
      className = 'right-text';
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined) {
          component = (
            <span className={className}>{value + ' ' + appendText}  </span>
          );
        } else {
          component = <span className={className}>{nodashes ? '' : '-'}</span>;
        }
      } else {
        return value;
      }
      break;
    case 'DateTime':
    case 'Date':
      className = 'date-text';
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined && value !== '0001-01-01T00:00:00' && value !== '5000-01-01T00:00:00') {
          component = (
            <span className={className}>{moment(value).format('MM/DD/YYYY') + ' ' + appendText}  </span>
          );
        } else {
          component = <span className={className}>{nodashes ? '' : '-'}</span>;
        }
      } else {
        if (value !== null && value !== '' && value !== undefined && value !== '0001-01-01T00:00:00' && value !== '5000-01-01T00:00:00') {
          return moment(value).format('YYYY/MM/DD');
        } else {
          return null;
        }
      }
      break;
    case 'Year':
      className = 'date-text';
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined && value !== '0001-01-01T00:00:00' && value !== '5000-01-01T00:00:00') {
          const formattedDate = moment(value).format('YYYY/MM/DD');
          component = (
            <span className={className}>{moment(formattedDate, 'YYYY/MM/DD').year() + ' ' + appendText}  </span>
          );
        } else {
          component = <span className={className}>{nodashes ? '' : '-'}</span>;
        }
      } else {
        if (value !== null && value !== '' && value !== undefined && value !== '0001-01-01T00:00:00' && value !== '5000-01-01T00:00:00') {
          return moment(value).format('YYYY/MM/DD');
        } else {
          return null;
        }
      }
      break;

    case 'Number':
      className = 'number-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value !== null && isNaN(value) !== true) {
          component = <span className={className}>{numberWithCommas(value) + ' ' + appendText}</span>;
        } else {
          component = <span className={className}>{nodashes ? '' : '-'}</span>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
        } else {
          return 0;
        }
      }
      break;

    case 'Decimal':
      className = 'number-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (isNaN(value) !== true) {
          component = (
            <span className={className}>
              {numberWithCommas(parseFloat(value).toFixed(2)) + ' ' + appendText}
            </span>
          );
        } else {
          component = <span className={className}>{nodashes ? '' : '-'}</span>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseFloat(parseFloat(value).toFixed(2));
        } else {
          return 0;
        }
      }
      break;

    case 'MoneyNumber':
      className = 'number-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>$0</span>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <span className={className}>${numberWithCommas(parseInt(value)) + ' ' + appendText}</span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>${numberWithCommas(parseInt(oldValue)) + ' ' + appendText}</span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
        } else {
          return 0;
        }
      }
      break;

    case 'MoneyDecimal':
      className = 'number-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = !isSensitive ? <span className={className}>$0</span> : <span className={className}>xxx</span>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <span className={className}>
                ${!isSensitive
                  ? (column?.decimalPrecision === 2
                    ? numberWithCommas(with2DecimalsPoints(parseFloat(parseFloat(value)), 'Percent'))
                    : numberWithCommas(with2DecimalsPoints(parseFloat(parseFloat(value)), isReportFormat)))
                  : 'xxx'}
              </span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>
                $({numberWithCommas(with2DecimalsPoints(parseFloat(oldValue), isReportFormat))})
              </span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else if (value === '' || isNaN(value) === true) {
        return 0;
      } else {
        if (isNaN(value) !== true) {
          if (value?.toString().substr(value?.length - 1) === '.') { return value; }
          return (with2DecimalsPoints(parseFloat(value)));
        } else {
          return 0;
        }
      }
      break;

    case 'Percent':
      className = 'percent-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>0%</span>;
        } else if (isNaN(value) !== true) {
          component = <span className={className + ' ' + classes}>{numberWithCommas(parseInt(value))}% {' ' + appendText}</span>;
        } else {
          component = <span className={className + ' ' + classes}>-</span>;
        }
      } else {
        if (value !== null && value === '') {
          return 0;
        } else if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
          // return parseFloat(value).toFixed(2);
        } else {
          return 0;
        }
      }
      break;

    case 'DecimalPercent':
      className = 'percent-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>0%</span>;
        } else if (isNaN(value) !== true && value !== null) {
          if (value >= 0) {
            component = (
              <span className={className}>
                {numberWithCommas(with2DecimalsPoints(parseFloat(value), 'Percent'))}%
              </span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>
                ({numberWithCommas(with2DecimalsPoints(parseFloat(oldValue), 'Percent'))})% {' ' + appendText}
              </span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else if (value === '' || value.length === 0 || isNaN(value) === true) {
        return 0;
      } else {
        if (value !== null && isNaN(value) !== true) {
          return with2DecimalsPoints(parseFloat(value));
          // let remainder = (value?.toString() || '').split('.')[1];
          // if (remainder && remainder.toString().length > 1 && remainder.toString().substring(0, 1) === "0") {
          //   return parseFloat(parseInt(value) + '.' + remainder.toString().substring(1, 2)).toFixed(1);
          // }
          // if (remainder === "" || remainder === "0") {
          //   return (parseFloat(value) % 1 !== 0 ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(1));//parseInt(value));
          // }
          // else {
          //   return (parseFloat(value) % 1 !== 0 ? parseFloat(value).toFixed(2) : parseInt(value));//parseInt(value));
          // }
        } else {
          return 0;
        }
      }
      break;
    case 'Boolean':
    case 'Radio':
      className = 'boolean-text';
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value !== undefined) {
          component = <span className={className}>{value ? 'Yes' : 'No'}</span>;
        } else {
          component = <span className={className}>-</span>;
        }
      } else {
        if (value !== undefined) {
          return value;
        } else {
          return false;
        }
      }
      break;
    case 'MultiText': {
      let arr = [];
      if (typeof value === 'string') {
        arr.push(value);
      } else {
        arr = value;
      }
      const tags = removeDuplicates(arr || []);
      // if (tags.length === 0) {
      //   return '-';
      // }
      let compareValuesArray = [];
      let changeClassOfChip = false;
      if (column !== undefined && column.applyClassBasedOn !== undefined) {
        const compareValues = row[column.applyClassBasedOn];
        compareValuesArray = compareValues?.split('|');
        changeClassOfChip = compareValuesArray?.length > 0;
      }
      if (noFormatting === false) {
        component = (
          <>
            {tags.length > 0
              ? (tags.map(
                (chip, i) =>
                  (column === undefined ||
                    column.minTag === undefined ||
                    i < column.minTag) &&
                  chip &&
                  chip !== '' && (
                    <Chip
                      key={chip + i}
                      className={(compareValuesArray || []).includes(chip) ? 'chip' : 'info chip'}
                      size="small"
                      label={chip}
                      title={chip}
                    ></Chip>
                  )
              ))
              : '-'
            }
            {}
            {
              column && column.minTag && tags?.length > column.minTag &&
              (<span style={{ cursor: 'pointer' }} className={column.viewTagClasses} onClick={() => viewTagData !== undefined &&
                viewTagData(column.name, tags.map(
                  (chip, i) =>
                    chip &&
                    chip !== '' && (
                      <Chip
                        key={chip + i}
                        className={(compareValuesArray || []).includes(chip) ? 'chip' : 'info chip'}
                        size="small"
                        label={chip}
                      ></Chip>
                    )
                ))} ><br />{column.minTagLabel || '... View all'} </span>)
            }
          </>
        );
      } else {
        return value;
      }
      break;
    }
    case 'RightAlign':
      className = 'right-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        component = <span className={className}>{value + ' ' + appendText}</span>;
      } else {
        return value;
      }
      break;
    default:
      if (noFormatting === false) {
        component = (
          <span className="default-text">
            {(column || {}).prefixChild}
            {value === '' || value === null ? '-' : value}
          </span>
        );
      } else {
        return value;
      }
  }

  return component;
}

function getWithoutFormattedValues(value, format, noFormatting = false, column = undefined, prop = undefined,
  viewTagData = undefined, appendText = '', isEditableMode = false, nodashes = false) {
  let component = <></>;
  let classes = '';
  let className = '';
  if (column && column.applyColorBadge) {
    classes = ' applyColorBadge';
  }

  if (value === false && format === 'Text' && noFormatting !== true) {
    return component;
  }

  switch ((format || '').trim()) {
    case 'Text':
      if (noFormatting === false) {
        if (value !== null && value !== '' && value !== undefined) {
          component = (
            <span className="default-text">{value + ' ' + appendText}  </span>
          );
        } else {
          component = <span className="default-text">{nodashes ? '' : '-'}</span>;
        }
      } else {
        return value;
      }
      break;
    case 'Hours':
      className = 'default-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>0hr</span>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <span className={className}>{numberWithCommas(parseInt(value)) + 'hr ' + appendText}</span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>${numberWithCommas(parseInt(oldValue)) + 'hr ' + appendText}</span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
        } else {
          return 0;
        }
      }
      break;
    case 'MoneyNumber':
      className = 'default-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>$0</span>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <span className={className}>${numberWithCommas(parseInt(value)) + ' ' + appendText}</span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>${numberWithCommas(parseInt(oldValue)) + ' ' + appendText}</span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
        } else {
          return 0;
        }
      }
      break;

    case 'Percent':
      className = 'default-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>0%</span>;
        } else if (isNaN(value) !== true) {
          component = <span className={className + ' ' + classes}>{numberWithCommas(parseInt(value))}% {' ' + appendText}</span>;
        } else {
          component = <span className={className + ' ' + classes}>-</span>;
        }
      } else {
        if (value !== null && value === '') {
          return 0;
        } else if (value !== null && isNaN(value) !== true) {
          return parseInt(value);
          // return parseFloat(value).toFixed(2);
        } else {
          return 0;
        }
      }
      break;

    case 'DecimalPercent':
      className = 'default-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>0%</span>;
        } else if (isNaN(value) !== true && value !== null) {
          if (value >= 0) {
            component = (
              <span className={className}>
                {numberWithCommas((parseFloat(value)?.toFixed(2)))}%
              </span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>
                ({numberWithCommas((parseFloat(oldValue)?.toFixed(2)))})% {' ' + appendText}
              </span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else if (value === '' || value.length === 0 || isNaN(value) === true) {
        return 0;
      } else {
        if (value !== null && isNaN(value) !== true) {
          return parseFloat(parseFloat(value)?.toFixed(2));
        } else {
          return 0;
        }
      }
      break;
    case 'MoneyDecimal':
      className = 'default-text' + (prop?.config?.sorting === false ? ' no-padding' : '');
      if (isEditableMode === true) {
        className = 'default-text';
      }
      if (noFormatting === false) {
        if (value === null || (value?.toString() || '').trim() === '') {
          component = <span className={className}>$0</span>;
        } else if (isNaN(value) !== true) {
          if (value >= 0) {
            component = (
              <span className={className}>
                ${numberWithCommas(parseFloat(parseFloat(value)?.toFixed(2)))}
              </span>
            );
          } else {
            var newValue = value?.toString();
            var oldValue = newValue?.substr(1);
            component = (
              <span className={className}>
                $({numberWithCommas(parseFloat(parseFloat(oldValue)?.toFixed(2)))})
              </span>
            );
          }
        } else {
          component = <span className={className}>-</span>;
        }
      } else if (value === '' || isNaN(value) === true) {
        return 0;
      } else {
        if (isNaN(value) !== true) {
          if (value?.toString().substr(value?.length - 1) === '.') { return value; }
          return parseFloat(parseFloat(value)?.toFixed(2).toLocaleString());
        } else {
          return 0;
        }
      }
      break;
  }

  return component;
}

function getFormattedValuesForGraph(value, format, noFormatting = false, column = undefined, prop = undefined,
  viewTagData = undefined, appendText = '', isEditableMode = false, nodashes = false) {
  const component = '';
  if (value === false && format === 'Text' && noFormatting !== true) {
    return component;
  }

  switch ((format || '').trim()) {
    case 'Text':
    case 'TextNew':
      return value;
      break;
    case 'DateTime':
    case 'Date':
      if (value !== null && value !== '' && value !== undefined && value !== '0001-01-01T00:00:00') {
        return moment(value).format('YYYY/MM/DD');
      } else {
        return '-';
      }
    case 'Number':
      if (value !== null && isNaN(value) !== true) {
        return numberWithCommas(parseInt(value));
      } else {
        return 0;
      }
      break;

    case 'Decimal':
    case 'DecimalNumber':
    case 'NumberDecimal':
      if (value !== null && isNaN(value) !== true) {
        return numberWithCommas(parseFloat(value).toFixed(2));
      } else {
        return 0;
      }
      break;
    case 'MoneyNumber':
    case 'NumberMoney':
    case 'Money':
      if (value !== null && isNaN(value) !== true) {
        return '$' + numberWithCommas(parseInt(value));
      } else {
        return '$0';
      }
      break;

    case 'MoneyDecimal':
    case 'DecimalMoney':
      if (value === '' || isNaN(value) === true) {
        return '$0';
      } else {
        if (isNaN(value) !== true) {
          if (value?.toString().substr(value?.length - 1) === '.') { return value; }
          return '$' + numberWithCommas(parseFloat(value)?.toFixed(2));
        } else {
          return '$0';
        }
      }
      break;

    case 'Percent':

      if (value !== null && value === '') {
        return '0%';
      } else if (value !== null && isNaN(value) !== true) {
        return numberWithCommas(parseInt(value)) + '%';
        // return parseFloat(value).toFixed(2);
      } else {
        return '0%';
      }

      break;

    case 'DecimalPercent':
    case 'PercentDecimal':
      if (value === '' || value.length === 0 || isNaN(value) === true) {
        return '0%';
      } else {
        if (value !== null && isNaN(value) !== true) {
          return numberWithCommas(parseFloat(value)?.toFixed(2)) + '%';
        } else {
          return '0%';
        }
      }
      break;
    case 'Boolean':
    case 'Radio':

      if (value !== undefined) {
        return value.toString();
      } else {
        return 'false';
      }

      break;
    case 'MultiText': {
      return value;

      break;
    }
    case 'RightAlign':

      return value;

      break;
    default:

      return value;
  }
}

function getFormattedHeaders(value, format) {
  let component = <></>;
  switch ((format || '').trim()) {
    case 'TextNew':
      component = <span className="right-text table-header"><p className='default-text'>{value}</p></span>;
      break;
    case 'DateTime':
    case 'Date':
      component = <span className="date-text table-header"><p className='date-text'>{value}</p></span>;
      break;
    case 'Number':
    case 'Decimal':
    case 'MoneyNumber':
    case 'MoneyDecimal':
      component = <span className="number-text table-header"><p className='number-text'>{value}</p></span>;
      break;
    case 'RightAlign':
      component = <span className="right-text table-header"><p className='number-text'>{value}</p></span>;
      break;
    case 'Percent':
    case 'DecimalPercent':
      component = <span className="percent-text table-header"><p className='percent-text'>{value}</p></span>;

      break;

    case 'Boolean':
    case 'Radio':

      component = <span className="boolean-text table-header"><p className='boolean-text'>{value}</p></span>;

      break;

    default:

      component = (
        <span className="default-text table-header">

          {value}
        </span>
      );
  }
  return component;
}
export { getFormattedHeaders, getFormattedValuesForGraph };
function getCollapsibleIcon(row, col, handelClick, key, isOpen) {
  return (
    <IconButton
      key={col.key + key + row[col.key]}
      aria-label="expand row"
      size="small"
      style={{ padding: '0px', cursor: 'pointer' }}
      onClick={(e) => {
        e.stopPropagation();
        handelClick(col.key, row[col.key] + row.marketId?.toString() + row.indexKey?.toString(), !isOpen);
      }}
    >
      {isOpen ? <Remove className="collapse-button" fontSize={'small'} /> : <Add className="collapse-button" fontSize={'small'} />}
    </IconButton>);
}

export function formatExcelData(format, value) {
  switch ((format || '').trim()) {
    case 'Text':
      if (value !== null && value !== '' && value !== undefined) {
        value = value;
      } else {
        value = '-';
      }
      break;
    case 'DateTime':
    case 'Date':
      if (value !== null && value !== '' && value !== undefined && value !== '0001-01-01T00:00:00') {
        value = moment(value).format('MM/DD/YYYY');
      } else {
        value = '-';
      }
      break;

    case 'Number':
      if (value !== null && value !== undefined && value !== '' && isNaN(value) !== true) {
        value = parseInt(value);
      } else {
        value = 0;
      }
      break;

    case 'Decimal':
      if (value !== null && value !== undefined && value !== '' && isNaN(value) !== true) {
        value = parseFloat(parseFloat(value).toFixed(2));
      } else {
        value = 0;
      }
      break;

    case 'MoneyNumber':
      if (value !== null && value !== undefined && value !== '' && isNaN(value) !== true) {
        value = parseInt(value);
      } else {
        value = 0;
      }
      break;

    case 'MoneyDecimal':
      if (value === '' || isNaN(value) === true) {
        value = 0;
      } else {
        if (value !== undefined && value !== '' && value !== null && isNaN(value) !== true) {
          if (value.toString().substr(value.length - 1) === '.') { return value; }
          value = parseFloat(parseFloat(value).toFixed(2).toLocaleString());
        } else {
          value = 0;
        }
      }
      break;

    case 'Percent':
      if (value !== undefined && value !== '' && value !== null && isNaN(value) !== true) {
        value = parseInt(value);
      } else {
        value = 0;
      }
      break;

    case 'DecimalPercent':
      if (value === '' || value.length === 0 || isNaN(value) === true) {
        value = 0;
      } else {
        if (value !== undefined && value !== '' && value !== null && isNaN(value) !== true) {
          value = parseFloat(parseFloat(value).toFixed(2));
        } else {
          value = 0;
        }
      }
      break;
    case 'Boolean':
    case 'Radio':
      if (value !== undefined && value === true) {
        value = 'Yes';
      } else {
        value = 'No';
      }
      break;
  }

  return value;
}

function getFieldValueByFormat(obj) {
  return getFormattedValues(obj.attributeValue, obj.dataFormat, true);
}

export { getFieldValueByFormat };
function applyBadge(component, value, inEditMode) {
  if (value === undefined || isNaN(value)) {
    return component;
  }
  const val = parseInt(value);
  let colorClass = 'standardError';
  if (val > 0 && val <= 30) {
    colorClass = 'message';
  }
  if (val > 30 && val <= 70) {
    colorClass = 'info';
  }
  if (val > 70 && val <= 100) {
    colorClass = 'success';
  }
  if (val > 100) {
    colorClass = 'standardError';
  }
  if (inEditMode !== true) {
    return <Chip className={colorClass + ' float-right'} size="small" label={component}></Chip>;
  } else {
    return <Chip className={colorClass} size="small" label={component}></Chip>;
  }
}
